module.exports = __webpack_public_path__ + "img/3.6a20f0c.png";